import { Component, h } from 'preact'
import { InstantSearch, Configure } from 'react-instantsearch-dom'
import globals from '../../utils/globals'
import algoliasearch from 'algoliasearch/lite'
import { RelatedIdeasList } from './RelatedIdeasList'
import { Credentials, getSearchToken } from '../../services/algoliaService'

interface Props {
  pageSize: number
  topicTitle: string
}

interface State {
  token?: string
  clientId?: string
}
class RelatedIdeas extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {}
    this.cb = this.cb.bind(this)
  }

  communityId: string = globals('communityId')
  topicId: string = window.inSidedData.content.topic.id

  cb (data: Credentials) {
    this.setState({
      clientId: data.client_id,
      token: data.token
    })
  }

  componentDidMount () {
    getSearchToken(this.cb)
  }

  render ({ pageSize = 5, topicTitle }: Props, { token, clientId }: State) {
    if (!clientId || !token) return null
    return (
      <div>
        <InstantSearch
          searchClient={algoliasearch(clientId, token)}
          indexName={this.communityId}
        >
          <Configure
            queryType='prefixNone'
            query={topicTitle}
            hitsPerPage={pageSize + 1}
            facetFilters={[['content_type:ideation']]}
            removeWordsIfNoResults='allOptional' optionalWords={topicTitle}
            analyticsTags={['destination', 'related']}
          />
          <RelatedIdeasList topicId={this.topicId} totalItemCount={pageSize} />
        </InstantSearch>
      </div>
    )
  }
}

export default RelatedIdeas
